/**
 * Minimum number of characters required to trigger a search. This is imposed
 * by the API.
 */
export const SEARCH_MIN_CHARS = 3;
